import React from "react";
import ProductStockGroupService from "services/product-stock-group";

import { connect } from "react-redux";
import { loadGroup } from "reducers/product";

class Product extends React.Component {
  productStockGroupService = new ProductStockGroupService();

  constructor() {
    super(...arguments);
    this.load();
  }

  async load() {
    await this.productStockGroupService
      .getAll()
      .then(({ data }) => this.props.loadGroup(data));
  }

  render() {
    return null;
  }
}

export default connect(null, { loadGroup })(Product);
